import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import useLog from "../hooks/useLog.hk";
import { videoPlay } from "../store/features/VideoSlice";
import { googleAnalyticsTracker } from "../utils/google";
import { getHost } from "../utils/host";
import "./videoLink.cmp.scss";

const CmpVideoLink = ({ video, cssClass = "col-12 col-sm-6 col-lg-4" }) => {
	const [, logVideo] = useLog();
	const videoData = useSelector(state => state.video);
	const username = useSelector(state => state.user.username);
	const dispatch = useDispatch();

	return <div className = {`cmp-video-link ${cssClass} ${videoData.currVideo?.videoId == video.videoId? "current" : ""}`}>
		<button title = {`${video.title} [${video.duration}]`} onClick = {handleVideoChange(videoData.videoProgress, logVideo, video, dispatch, username)}>
			<img src = {`${getHost()}${video.thumb}`} alt = ""/>
			<span className = "duration-badge">{video.duration}</span>
			<div className = "overlay">
				<FontAwesomeIcon icon = "play-circle"/>
				<div className = {`video-title ${getClass(video, videoData?.currVideo?.videoId)}`}>
					<span className = "t">{video.title}<span className = "d"> [{video.duration}]</span></span>
					{videoData.currVideo?.videoId == video.videoId ?
						<span className = "now-playing"><FontAwesomeIcon icon = "volume-up"/> In riproduzione</span> : null}
				</div>
			</div>
		</button>
	</div>
}

const getClass = (video, currVideoId) => video.videoId == currVideoId? "active" : "";

const handleVideoChange = (vProg, logVideo, video, dispatch, username) => () =>
	new Promise(() => {
		if (vProg.info.ranges.length > 0 && !vProg.videoEnded && !vProg.paused) {
			logVideo();
			googleAnalyticsTracker("videoplay", JSON.stringify(vProg.info), username);
		}
	})
	.then(dispatch(videoPlay({
  video: video,
  startTime: 100
})));

export default CmpVideoLink;